import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./styles/css/bootstrap.min.css";
import "./styles/css/style.css";
import "./styles/css/font-awesome.css";
import "rc-pagination/assets/index.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import NextApp from "./NextApp";
import Modal from "react-modal";

Modal.setAppElement("#root");

// ✅ Remove the process.env check - just disable console logs
console.log = () => {};
console.warn = () => {};
console.error = () => {};

ReactDOM.render(<NextApp />, document.getElementById("root"));

reportWebVitals();
